module.exports = __webpack_public_path__ + "img/47.344a9742.svg";